import React, { createContext, useReducer } from "react";
import { DEFAULT_LOCALE } from "constants";

const initialState = {
  locale: DEFAULT_LOCALE,
};

export const CHANGE_LOCALE = "CHANGE_LOCALE";

const reducer = (state, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };
    default:
      return { ...state };
  }
};

export const LocaleContext = createContext();

export const LocaleProvider = (props) => {
  const [localeState, dispatch] = useReducer(reducer, initialState);

  const actions = {
    changeLocale: (locale) => {
      if (locale) {
        dispatch({ type: CHANGE_LOCALE, payload: locale });
      }
    },
  };

  return (
    <LocaleContext.Provider
      value={{
        localeState: localeState,
        localeActions: actions,
      }}
    >
      {props.children}
    </LocaleContext.Provider>
  );
};
